<template>
  <a-descriptions bordered size="small" :column="2">
    <a-descriptions-item>
      <div slot="label" class="center">申领人</div>
      <div class="">
        {{ detail.extra.applicant }}
      </div>
    </a-descriptions-item>

    <a-descriptions-item :span="1">
      <div slot="label" class="center">申领部门</div>
      <div class="">
        {{ detail.extra.applicantDeptName }}
      </div>
    </a-descriptions-item>

    <a-descriptions-item>
      <div slot="label" class="center">申领事由</div>
      <div class="">
        {{ detail.extra.description }}
      </div>
    </a-descriptions-item>
  </a-descriptions>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("approval", ["detail"]),
  },
};
</script>

